import NavMenu from "../../common/NavMenu.js";

export default (el, index, callback) => {
  const globalHeaderEl = document.querySelector(".js-global-header");
  let openMenuID = -1;

  const onClose = (i) => {
    if (openMenuID === i) {
      openMenuID = -1;

      if (globalHeaderEl) {
        globalHeaderEl.classList.remove("is-expanded");
        globalHeaderEl.style.marginBottom = 0;
      }
    }
  };
  const onOpen = (i, margin) => {
    if (openMenuID !== i) {
      openMenuID = i;

      if (globalHeaderEl) {
        globalHeaderEl.style.marginBottom = `${margin}px`;
        globalHeaderEl.classList.add("is-expanded");
      }
    }
  };
  const primaryLinks = el.querySelectorAll(
    ".js-primary-nav-top-link, .js-primary-nav-menu-button",
  );

  primaryLinks.forEach((el, i) => {
    el.addEventListener("keydown", (e) => {
      handleKeyDown(e, i);
    });
  });
  el.querySelectorAll(".js-primary-nav-menu").forEach((el, i) => {
    const contentEl = el.querySelector(".js-primary-nav-menu-content");

    NavMenu({
      animationDelay: 500,
      closed: true,
      direction: "vertical",
      menuButton: ".js-primary-nav-menu-button",
      menuContainer: ".js-primary-nav-menu-content",
      navigationLink: ".js-primary-nav-sub-link",
      openClass: "is-open",
      onClose: () => onClose(i),
      onOpen: () => onOpen(i, contentEl.offsetHeight),
      parent: el,
    });
  });

  function handleKeyDown(event, index) {
    switch (event.key) {
      case "Left":
      case "ArrowLeft":
        if (index > 0) {
          event.preventDefault();
          primaryLinks[index - 1].focus();
        }
        break;
      case "Right":
      case "ArrowRight":
        if (index < primaryLinks.length - 1) {
          event.preventDefault();
          primaryLinks[index + 1].focus();
        }
        break;
      default:
    }
  }
};
